/**
 * Cloudflare's always-pass TEST sitekey (24 chars — not to be confused with the
 * 35-char test SECRET, which produces a widget that fails to render with error
 * 400020). Exported so the boot-time guard in services/monitoring.ts can shout
 * if a deployed bundle ever ships it.
 */
export const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA';

const config = {
  baseURL: process.env.REACT_APP_BASE_URL || 'http://localhost:8080',
  appUsername: process.env.REACT_APP_APP_USERNAME || '',
  appPassword: process.env.REACT_APP_APP_PASSWORD || '',
  // Cloudflare Turnstile SITE key — public by design (it ships in the bundle);
  // the paired SECRET key lives only on the backend. Defaults to the test key
  // so local dev works with no env file. Every deployed build MUST set
  // REACT_APP_TURNSTILE_SITE_KEY to the real key (see
  // .github/workflows/deploy.yml) — a test-key token is rejected by siteverify
  // against the real secret, and the backend fails closed.
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY || TURNSTILE_TEST_SITE_KEY,
  // Sentry ORGANISATION SLUG — the `<org>` in
  // `https://sentry.io/organizations/<org>/issues/`. Public by design (it is a
  // path segment in a URL an operator pastes), and NOT derivable from
  // REACT_APP_SENTRY_DSN, which carries the numeric org id (`o4511…`) instead.
  //
  // Empty is the supported state, not a misconfiguration: the admin System
  // page HIDES its Sentry links entirely rather than linking to
  // `/organizations//issues/`, which is a 404 that looks like a broken console.
  // Set REACT_APP_SENTRY_ORG in `.github/workflows/deploy.yml` to turn the
  // links on — CRA inlines it at BUILD time, so a value added after a deploy
  // does nothing until the next build.
  sentryOrg: process.env.REACT_APP_SENTRY_ORG || '',
};

export default config;
